// extracted by mini-css-extract-plugin
export var numpadContainer = "_nb-1";
export var phoneButton = "_nb-0";